import Vue from 'vue'
import Vuex from 'vuex'
import {Notice} from "@/main";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        news: [],
        lang: process.env.VUE_APP_I18N_LOCALE || 'en',
    },
  getters: {
    news: state => state.news,
    lang: state => state.lang,
    // activeNews: state => {
    //   return state.news.filter(n => n.active);
    // }
  },
    mutations: {
      change(state, news) {
        state.news = news
      },
      changeLocale(state, lang) {
        state.lang = lang
      }
    },
    actions: {},
    modules: {}
})

